module.exports = __webpack_public_path__ + "img/091_thumbnail.73468db6.jpg";